import { useMutation } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import React from 'react';
import { useForm } from 'react-hook-form';

import { passwordReset } from '../../../services/auth/password-reset';
import { useAddAlert } from '../../modules/alerts';

import PasswordRecoverFormContent from './form-content';

const PasswordRecoverForm = () => {
  const { t } = useTranslation();
  const { locale = 'en' } = useRouter();
  const addAlert = useAddAlert();
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isValid },
  } = useForm({ mode: 'onChange' });

  const { mutate, isLoading } = useMutation(passwordReset, {
    onSuccess() {
      addAlert({
        id: 'password-reset',
        text: t('password-reset:success'),
        type: 'SUCCESS',
        autoClose: true,
      });
    },
    onError(error: Record<string, any>) {
      addAlert({
        id: 'password-reset',
        text: error.serverError
          ? t('forms:errors.serverError')
          : t('password-reset:error'),
        items: error.non_field_errors,
        type: 'DANGER',
      });
      Object.keys(error).map(function (key, i) {
        if (key !== 'non_field_errors' && key !== 'serverError') {
          setError(key, {
            type: 'manual',
            message: error[key],
          });
        }
      });
    },
  });

  const onSubmit = useCallback(
    (formData) => {
      mutate({
        locale: locale,
        formData,
        csrftoken: Cookies.get('csrftoken') || '',
      });
    },
    [mutate, locale]
  );

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="lg:px-4 pt-6 flex flex-col gap-4 w-full lg:w-2/3"
      >
        <PasswordRecoverFormContent
          register={register}
          errors={errors}
          disabled={isLoading}
          isValid={isValid && Object.keys(errors).length == 0 && !isLoading}
        />
      </form>
    </>
  );
};
export default PasswordRecoverForm;
